module.exports = __webpack_public_path__ + "img/connor-pfp.48a2664e.webp";